import type { ReactElement } from 'react';
import { AlertTriangle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { getErrorMessage } from '@/hooks/api/errorHelpers';

export interface SsoStatusErrorProps {
  error: unknown;
  onRetry: () => void;
  isRetrying?: boolean;
}

export function SsoStatusError({
  error,
  onRetry,
  isRetrying = false,
}: SsoStatusErrorProps): ReactElement {
  return (
    <div
      role="alert"
      data-testid="saml-status-error"
      className="flex items-start gap-2 rounded-md border border-destructive/30 bg-destructive/5 px-3 py-2 text-xs text-destructive"
    >
      <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <div className="flex-1 space-y-2">
        <p>Couldn’t load SSO settings. {getErrorMessage(error)}</p>
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={onRetry}
          disabled={isRetrying}
          data-testid="saml-status-error-retry"
        >
          {isRetrying ? 'Retrying…' : 'Try again'}
        </Button>
      </div>
    </div>
  );
}
